import { useState } from "react";
import axios from "axios";
import {
  Alert,
  Box,
  Grid,
  LinearProgress,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import DataTable from "react-data-table-component";

const columns = [
  {
    name: "ANNEE",
    selector: (row) => row.annee,
    sortable: true,
  },
  {
    name: "MOIS",
    selector: (row) => row.mois,
    sortable: true,
  },
  {
    name: "SALAIRE DE BASE",
    selector: (row) => row.salaire_base,
    sortable: true,
  },
  {
    name: "COTISATION",
    selector: (row) => row.cotisation_employee,
    sortable: true,
  },
  {
    name: "POINT",
    selector: (row) => row.points,
    sortable: true,
  },
];

const ListeCotisationClientDetaches = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [matricule, setMatricule] = useState("");
  // helper removed: searchInformation is no longer used (search handled via form submit)

  const nombreTotal = () => {
    return data.reduce((sum, item) => sum + (Number(item.points) || 0), 0);
  };

  const fetchData = async () => {
    if (matricule === "") {
      setError("Veuillez entrer un matricule");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`cotisation_detaches/${matricule}`);
      const json = await response.data;
      setData(json);
      if (json.length === 0) {
        setError("Aucun résultat");
      }
    } catch (error) {
      setError(error);
    }
    setLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    fetchData();
  };

  const exportCsv = () => {
    if (!data || data.length === 0) return;
    const headers = Object.keys(data[0]);
    const csv = [headers.join(",")]
      .concat(
        data.map((row) => headers.map((h) => `"${row[h] ?? ""}"`).join(",")),
      )
      .join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "cotisations_detaches.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}
      >
        <TextField
          size="small"
          value={matricule}
          onChange={(e) => setMatricule(e.target.value)}
          placeholder="Saisissez ici votre Numéro matricule ONPR"
          helperText={error || ""}
          error={!!error}
          sx={{ flex: "1 1 320px" }}
        />
        <Button variant="contained" type="submit">
          Consulter
        </Button>
      </form>

      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">Liste des cotisations</Typography>
      </Box>

      {loading && (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      )}
      {error && <Alert severity="error">{error}</Alert>}

      {!error && Array.isArray(data) && data.length !== 0 && (
        <Box>
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1">
                    RELEVE DES COTISATIONS DE :{" "}
                  </Typography>
                  <Typography variant="body2">
                    NOM ET PRENOM : {data[0]?.nom} {data[0]?.prenom}
                  </Typography>
                  <Typography variant="body2">
                    Matricule : {data[0]?.matricule}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ textAlign: { xs: "left", md: "right" } }}
                >
                  <Typography variant="body2">
                    NOMBRE DE MOIS TOTAL : {data.length}
                  </Typography>
                  <Typography variant="body2">
                    TOTAL DES POINTS : {nombreTotal()}
                  </Typography>
                  <Box sx={{ mt: 1 }}>
                    <Button variant="outlined" onClick={exportCsv}>
                      Exporter CSV
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <DataTable columns={columns} data={data} pagination={true} />
            </CardContent>
          </Card>
        </Box>
      )}
    </div>
  );
};

export default ListeCotisationClientDetaches;
